import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs } from 'react-bootstrap';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import piPermissions from '../../../../components/pi-permission';
import styles from './styles.css';
import { clearCache } from '../../../../components/dynamic-cell/actions';
import ProgessBar from '../../../../components/progress-bar';
import AccessChart from './charts/access-chart';
import ClientChart from './charts/client-chart';
import UserChart from './charts/user-chart';
import OpportunityChart from './charts/opportunity-chart';
import AccountChart from './charts/account-chart';
import BotChart from './charts/bot-chart';
import StatsTable from './components/stats-table';

import { fetchTruSalesStats } from '../../AdminActions';

/*
function createBarData(categories) {
  const data = [];
  const endDate = new Date();
  const startDate = new Date();
  startDate.setFullYear(startDate.getFullYear() - 3);
  const timestamps = [];

  for (let d = new Date(startDate); d <= endDate; d.setMonth(d.getMonth() + 1)) {
    const adminValue = Math.floor(Math.random() * 1001);
    const userValue = Math.floor(Math.random() * 1001);
    const managerValue = Math.floor(Math.random() * 1001);

    if (data.length === 0) {
      data.push([adminValue], [userValue], [managerValue]);
    } else {
      data[0].push(adminValue);
      data[1].push(userValue);
      data[2].push(managerValue);
    }

    timestamps.push(new Date(d));
  }

  return { data, categories, timestamps };
}

function createLineData() {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setFullYear(startDate.getFullYear() - 10);
  const data = [];
  for (let d = new Date(startDate); d <= endDate; d.setMonth(d.getMonth() + 1)) {
    data.push({
      timestamp: new Date(d),
      value: Math.floor(Math.random() * 1001)
    });
  }
  return data;
}

function createOpportunityData() {
  const outcomeCategories = ['Win', 'Loss', 'No decision'];
  const typeCategories = ['No business', 'Renewal', 'Addon', 'Upsell'];
  const sizeCategories = ['Small', 'Medium', 'Large'];

  const endDate = new Date();
  const startDate = new Date();
  startDate.setFullYear(startDate.getFullYear() - 3);
  const timestamps = [];

  const outcomeData = [];
  const typeData = [];
  const sizeData = [];

  for (let d = new Date(startDate); d <= endDate; d.setMonth(d.getMonth() + 1)) {
    for (let i = 0; i < outcomeCategories.length; i += 1) {
      const value = Math.floor(Math.random() * 1001);
      if (!outcomeData[i]) {
        outcomeData.push([value]);
      } else {
        outcomeData[i].push(value);
      }
    }

    for (let i = 0; i < typeCategories.length; i += 1) {
      const value = Math.floor(Math.random() * 1001);
      if (!typeData[i]) {
        typeData.push([value]);
      } else {
        typeData[i].push(value);
      }
    }

    for (let i = 0; i < sizeCategories.length; i += 1) {
      const value = Math.floor(Math.random() * 1001);
      if (!sizeData[i]) {
        sizeData.push([value]);
      } else {
        sizeData[i].push(value);
      }
    }

    timestamps.push(new Date(d));
  }

  const data = {
    outcome: outcomeData,
    type: typeData,
    size: sizeData,
    timestamps
  };

  return data;
}

function createTestData() {
  // Generate initial data for 10 years with a monthly timestamp
  const data = {};

  data.accounts = createLineData();
  data.bots = createLineData();
  data.clients = createLineData();
  data.access = createBarData(['Admins', 'Sales Managers', 'Sales Reps']);
  data.users = createBarData(['Admins', 'Sales Managers', 'Sales Reps']);
  data.opportunities = createOpportunityData();
  return data;
}
*/

function mapStatsData(data) {
  if (!data) {
    return {};
  }
  // Generate initial data structure
  const stats = {
    accounts: {
      data: [],
    },
    bots: {
      data: [],
    },
    clients: {
      data: [],
    },
    access: {
      data: [],
      categories: ['Admins', 'Sales Managers', 'Sales Reps'],
      timestamps: [],
    },
    users: {
      data: [],
      categories: ['Admins', 'Sales Managers', 'Sales Reps'],
      timestamps: [],
    },
    opportunities: {
      outcome: {
        data: [],
        categories: ['Win', 'Loss', 'No decision'],
      },
      type: {
        data: [],
        categories: ['No business', 'Renewal', 'Addon', 'Upsell'],
      },
      size: {
        data: [],
        categories: ['Small', 'Medium', 'Large'],
      },
      timestamps: [],
    },
  };

  data.timestamps = data.timestamps.map(value => new Date(value));

  stats.accounts = data.accounts.map((item, index) => [data.timestamps[index].getTime(), item.value]);
  stats.bots = data.bots.map((item, index) => [data.timestamps[index].getTime(), item.value]);
  stats.clients = data.clients.map((item, index) => [data.timestamps[index].getTime(), item.value]);

  stats.access.data = [
    data.access.admin,
    data.access.manager,
    data.access.user,
  ];
  stats.access.timestamps = data.timestamps;

  stats.users.data = [
    data.users.admin,
    data.users.manager,
    data.users.user,
  ];
  stats.users.timestamps = data.timestamps;

  stats.opportunities.outcome = [
    data.opportunities.outcome.win,
    data.opportunities.outcome.lose,
    data.opportunities.outcome.noDecision,
  ];
  stats.opportunities.type = [
    data.opportunities.type.new,
    data.opportunities.type.renewal,
    data.opportunities.type.addon,
    data.opportunities.type.upsell,
  ];
  stats.opportunities.size = [
    data.opportunities.size.small,
    data.opportunities.size.medium,
    data.opportunities.size.large,
  ];
  stats.opportunities.timestamps = data.timestamps;

  return stats;
}

function mapStatsDataForTable(data) {
  if (!data) {
    return [];
  }

  const timestamps = data.timestamps.map(value => new Date(value));

  const tableData = timestamps.map((timestamp, index) => ({
    time: timestamp,
    'users.admin': data.users.admin[index] || 0,
    'users.salesManager': data.users.manager[index] || 0,
    'users.salesRep': data.users.user[index] || 0,
    'access.admin': data.access.admin[index] || 0,
    'access.salesManager': data.access.manager[index] || 0,
    'access.salesRep': data.access.user[index] || 0,
    accounts: data.accounts[index]?.value || 0,
    clients: data.clients[index]?.value || 0,
    bots: data.bots[index]?.value || 0,
    'opportunities.outcome.win': data.opportunities.outcome.win[index] || 0,
    'opportunities.outcome.lose': data.opportunities.outcome.lose[index] || 0,
    'opportunities.outcome.noDecision': data.opportunities.outcome.noDecision[index] || 0,
    'opportunities.type.new': data.opportunities.type.new[index] || 0,
    'opportunities.type.renewal': data.opportunities.type.renewal[index] || 0,
    'opportunities.type.addon': data.opportunities.type.addon[index] || 0,
    'opportunities.type.upsell': data.opportunities.type.upsell[index] || 0,
    'opportunities.size.small': data.opportunities.size.small[index] || 0,
    'opportunities.size.medium': data.opportunities.size.medium[index] || 0,
    'opportunities.size.large': data.opportunities.size.large[index] || 0,
  }));

  return [...tableData].reverse();
}

class ClientStatsPage extends Component {
  constructor() {
    super();
    this.state = {
      selectedTab: 'access',
      selectedChart: 'access',
      data: null,
      tableData: null,
      loading: true,
      loaded: false,
      errors: null,
    };
    this.onTabSelect = this.onTabSelect.bind(this);
    this.handleChartSelection = this.handleChartSelection.bind(this);
  }

  componentDidMount() {
    clearCache(this.props.dispatch);
    this.props.dispatch(fetchTruSalesStats())
      .then(
        () => {
          this.setState({ loading: false, loaded: true, errors: null, })
        },
        (e) => {
          this.setState({ loading: false, loaded: false, errors: e.data?.message });
        },
      );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data, tableData: this.props.tableData });
    }
  }

  onTabSelect(selectedTab) {
    this.setState({ selectedTab });
  }

  handleChartSelection(eventKey) {
    this.setState({ selectedChart: eventKey });
  }

  render() {
    const { data, loaded, loading, errors } = this.state;
    return (
      <div>
        <Helmet title="Client Stats" />
        <p />
        {loading && <div className="container"><ProgessBar /></div>}
        {errors !== null && <div className="container"><div className="alert alert-danger">{errors}</div></div>}
        {loaded && data !== null && 
          <div className={styles.graphWrapper}>
            <div className="container">
                <Tabs
                  defaultActiveKey={this.state.selectedTab}
                  id="analysis-tabs"
                  animation
                  mountOnEnter
                  unmountOnExit
                  onSelect={this.onTabSelect}
                  className={styles.chartTab}
                >
                  <Tab eventKey="access" title="Access">
                    <AccessChart data={data.access} />
                  </Tab>
                  <Tab eventKey="clients" title="Clients">
                    <ClientChart data={data.clients} />
                  </Tab>
                  <Tab eventKey="users" title="Users">
                    <UserChart data={data.users} />
                  </Tab>
                  <Tab eventKey="opportunities" title="Opportunities">
                    <OpportunityChart data={data.opportunities} />
                  </Tab>
                  <Tab eventKey="accounts" title="Accounts">
                    <AccountChart data={data.accounts} />
                  </Tab>
                  <Tab eventKey="bot" title="Bot Clients">
                    <BotChart data={data.bots} />
                  </Tab>
                </Tabs>
            </div>
          </div>
        }
        {loaded &&
          <div className="container">
            <StatsTable data={this.state.tableData} />
          </div>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { tsStats } = state.admin;
  return {
    data: mapStatsData(tsStats),
    tableData: mapStatsDataForTable(tsStats)
  };
}

ClientStatsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  tableData: PropTypes.array.isRequired
};

export default withRouter(connect(mapStateToProps)(piPermissions(ClientStatsPage, 'superadmin', 'admin')));
